// import { SelectOption, SelectValue } from "../SuperSelect/interface";

export function formarValue(value?: any): any[] | undefined {
  if (Array.isArray(value)) return value;
  if (value) return [value];
  return undefined;
}